var render = function render(_c,_vm){return _c('div',{staticClass:"nav-search-results__title text-commerce-intro text--w-regular text--uppercase text--clr-black"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }